export const toastErrorConfig = {
  className: 'access-toaster',
  type: 'error',
  heading: 'Something went wrong',
  message: 'Please try again',
}

export const toastSuccessConfig = {
  className: 'access-toaster',
  type: 'success',
  heading: 'Success',
}

export const toastCautionConfig = {
  className: 'access-toaster',
  type: 'alert' as const,
  heading: 'Warning',
}

export const toastInfoConfig = {
  className: 'access-toaster',
  type: undefined,
  heading: 'Information',
}
